import { CONTACT } from "../data";

export default function Footer({ onOpenLegal }) {
  return (
    <footer className="bg-pearl pt-20 pb-10" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-8">
          <img
            src="/img/logo.png"
            alt="Janna Schwartz"
            className="w-full max-w-[150px] md:max-w-[220px] h-auto object-contain"
          />
          <div className="flex flex-col items-start sm:items-end">
            <span className="text-[10px] tracking-[0.25em] uppercase text-muted mb-2 font-bold">Unsere Partner</span>
            <a 
              href="https://lilalaune-kids.de/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="hover:opacity-80 transition-opacity"
            >
              <img
                src="/img/lilalaune.png"
                alt="Lilalaune Kids"
                className="h-10 md:h-12 w-auto object-contain"
              />
            </a>
          </div>
        </div>
        <div className="mt-10 border-t border-line pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 text-xs tracking-[0.18em] uppercase text-muted">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <span>© {new Date().getFullYear()} Janna Schwartz</span>
            <span className="hidden sm:inline text-line/60">|</span>
            <button 
              onClick={() => onOpenLegal?.("impressum")} 
              className="hover:text-charcoal transition-colors cursor-pointer text-left focus:outline-none"
              data-testid="footer-impressum"
            >
              Impressum
            </button>
            <span className="hidden sm:inline text-line/60">|</span>
            <button 
              onClick={() => onOpenLegal?.("datenschutz")} 
              className="hover:text-charcoal transition-colors cursor-pointer text-left focus:outline-none"
              data-testid="footer-datenschutz"
            >
              Datenschutz
            </button>
            <span className="hidden sm:inline text-line/60">|</span>
            <span className="flex items-center gap-2">
              <span>Powered by</span>
              <a 
                href="https://jr-developer.de/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img 
                  src="/img/dev_small.png" 
                  alt="JR Developer" 
                  className="h-14 w-auto object-contain"
                />
              </a>
            </span>
          </div>
          <div className="flex gap-6">
            <a href={`mailto:${CONTACT.email}`} className="hover:text-charcoal transition-colors" data-testid="footer-email">
              {CONTACT.email}
            </a>
            <a href={`tel:${CONTACT.phone.replace(/[^+\d]/g, "")}`} className="hover:text-charcoal transition-colors" data-testid="footer-phone">
              {CONTACT.phone}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
